/**
 * Canonical registered office — keep in sync with tax records and legal pages.
 * Phone lives in contactDetails.ts. GBP pin / Maps URLs may differ from registered street.
 */
export const BUSINESS_LEGAL = {
  legalName: 'Büşra Diba Aktaş Mert',
  tradeName: 'Figtures',
  taxOffice: 'Kozyatağı',
  vkn: '0400545104',
} as const;

export const BUSINESS_LOCATION = {
  /** Kayıtlı merkez — vergi levhası / KVKK metinleri ile uyumlu. */
  streetLine: 'İçerenköy Mah. Topçu İbrahim Sok. Quick Tower Sit. No: 8-10D',
  locality: 'Ataşehir',
  region: 'İstanbul',
  countryCode: 'TR',
  /** GBP ziyaret pin — kayıtlı adresden farklı olabilir. */
  latitude: 40.9730695,
  longitude: 29.101168,
  googleMapsUrl:
    'https://www.google.com/maps/place/Figtures+Product+Studio/@40.9730695,29.101168,17z/data=!3m1!4b1!4m6!3m5!1s0x14cac7e1cfdf0b9b:0xd52665e861c35f54!8m2!3d40.9730695!4d29.101168!16s%2Fg%2F11nw7wfn48',
  googleMapsShareUrl: 'https://maps.app.goo.gl/EhTn62BodanXGSvq5',
  /** Pinned by coordinates: a name query ("Figtures Product Studio") resolves to the wrong area with no marker. */
  mapEmbedUrl: 'https://maps.google.com/maps?q=40.9730695,29.101168&hl=tr&z=17&output=embed',
} as const;

export function formatBusinessAddress(lang: 'tr' | 'en'): string {
  const { streetLine, locality, region } = BUSINESS_LOCATION;
  if (lang === 'tr') {
    return `${streetLine}, ${locality}/${region}`;
  }
  return `${streetLine}, ${locality}, ${region}, Turkey`;
}

export function formatBusinessLegalFooter(lang: 'tr' | 'en'): string {
  const { legalName, taxOffice, vkn, tradeName } = BUSINESS_LEGAL;
  if (lang === 'tr') {
    return `${tradeName}, ${legalName} markasıdır · ${taxOffice} VD · VKN ${vkn}`;
  }
  return `${tradeName} is a trademark of ${legalName} · ${taxOffice} Tax Office · VKN ${vkn}`;
}

export function buildPostalAddressSchema(): Record<string, string> {
  const { streetLine, locality, region, countryCode } = BUSINESS_LOCATION;
  return {
    '@type': 'PostalAddress',
    streetAddress: streetLine,
    addressLocality: locality,
    addressRegion: region,
    addressCountry: countryCode,
  };
}

export function buildGeoCoordinatesSchema(): Record<string, number | string> {
  return {
    '@type': 'GeoCoordinates',
    latitude: BUSINESS_LOCATION.latitude,
    longitude: BUSINESS_LOCATION.longitude,
  };
}
